import { CONFIG } from "./CONFIG";

/**
 * The momentum axis. The index is linear inside the steady band (−1 … 1)
 * and compressed beyond it: every doubling of the index takes the same
 * width, so 1, 2, 4, 8, 16 sit at 1, 2, 3, 4, 5. Steady stays readable, a
 * 3 and a 5 separate, and only a 16 reaches the edge — on shi a handful of
 * sub-topics sat at 15× the band and pinned to a linear edge of 3 along
 * with everything above it. Pure, so the field and the list's momentum bar
 * share one scale. Tooltips and the list keep the real index.
 */

// Index → plot position. Symmetric; the sign is preserved.
export const plotX = (index) => {
  const a = Math.abs(index);
  const capped = Math.min(a, CONFIG.FIELD_X_MAX);
  const plotted = capped <= 1 ? capped : 1 + Math.log2(capped);
  return Math.sign(index) * plotted;
};

// Plot position → index, for tick labels.
export const unplotX = (plotted) => {
  const a = Math.abs(plotted);
  const index = a <= 1 ? a : 2 ** (a - 1);
  return Math.sign(plotted) * index;
};

// Where the cap lands on the plot.
export const PLOT_X_MAX = plotX(CONFIG.FIELD_X_MAX);

// Ticks in plot units: the band edges, zero, and each doubling out to the cap.
export const PLOT_X_TICKS = (() => {
  const positive = [1];
  for (let index = 2; index <= CONFIG.FIELD_X_MAX; index *= 2) positive.push(plotX(index));
  return [...positive.map((t) => -t).reverse(), 0, ...positive];
})();
